'use strict';

import template from 'commons/templates/WorkingDaysModal.ejs';
import ModalFormView from 'commons/views/ModalForm.js';

module.exports = ModalFormView.extend({
    initialize(options) {
        this.options = Object.assign({
            template: template,
            actOnSave: false,
            actOnDestroy: false,
            actOnCancel: false
        }, options || {});

        this.company = options.company;
        this.location = options.location;
        this.isHQ = this.location && this.location.get('primary');
        this.isLocationWorkingDays = this.location &&
            this.location.get('workingDays');

        // different layout for
        // Kedah 02 , Kelantan 03 , Terenganu 11 , Johor 01
        this.address = this.location && this.location.getAddress();
        this.state = this.address && this.address.get('state');

        this.isSundayWeekStart = ['01', '02', '03', '11'].includes(this.state);
        this.weekdayList = this.isSundayWeekStart ?
            ['sunday', 'monday', 'tuesday', 'wednesday',
                'thursday', 'friday', 'saturday'] :
            ['monday', 'tuesday', 'wednesday',
                'thursday', 'friday', 'saturday', 'sunday'];

        this.workingDays = this.isLocationWorkingDays ?
            this.location.get('workingDays') :
            this.company.get('workingDays');

        ModalFormView.prototype.initialize.apply(this, [this.options]);
        this.render();
        return this;
    },

    render() {
        if (!this.options.template) {
            return null;
        }

        this.$el.html(
            this.options.template({
                weekdayList: this.weekdayList,
                workingDays: this.workingDays,
                isSundayWeekStart: this.isSundayWeekStart
            })
        );

        return this;
    },

    save() {
        const selector = 'input[type=radio]:checked';
        const elements = this.$el[0].querySelectorAll(selector);

        const workingDays = [];
        elements.forEach(e => workingDays.push(parseFloat(e.value)));

        // validate array
        if (workingDays.length !== 7) {
            return;
        }

        // rotate array one place to the right if isSundayWeekStart is true
        this.workingDays = this.isSundayWeekStart ?
            workingDays : [workingDays[6]].concat(workingDays.slice(0, 6));

        this.location.set('workingDays', this.workingDays);
        this.location.save();

        if (this.isHQ) {
            this.company.set('workingDays', this.workingDays);
        }

        this.hide();
    },

    //disable
    markMandatoryFields() {},
    bindHandlers() {},
    unbindHandlers() {}
});



// WEBPACK FOOTER //
// ./app/commons/views/WorkingDaysModal.js